module.exports = __webpack_public_path__ + "static/media/Programming_Essentials_in_Python.5039b814.pdf";